import { defineMessages } from 'react-intl';

/**
 * The texts of "Redo the kit with the new release date" (fym-shared `music24/dateRedo.ts`). The
 * parts that the cover redo has too (Not now, Cancel, the posts, the run cards) use its messages.
 */
export const dateRedoMessages = defineMessages({
  bannerTitle: {
    id: 'app.sml.releases.kit.dateRedo.banner.title',
    defaultMessage:
      'The release date changed. {count, plural, one {# asset shows} other {# assets show}} the old date.',
  },
  bannerBody: {
    id: 'app.sml.releases.kit.dateRedo.banner.body',
    defaultMessage: 'We write the new date into them and make them again. The layout and the look stay.',
  },
  dateChange: { id: 'app.sml.releases.kit.dateRedo.date.change', defaultMessage: '{old} → {new}' },
  noDate: { id: 'app.sml.releases.kit.dateRedo.date.none', defaultMessage: 'No date' },
  free: { id: 'app.sml.releases.kit.dateRedo.free', defaultMessage: 'Free' },
  freeNote: { id: 'app.sml.releases.kit.dateRedo.freeNote', defaultMessage: 'A new date costs no credits' },
  redo: {
    id: 'app.sml.releases.kit.dateRedo.redo',
    defaultMessage: '{count, plural, one {Fix # asset} other {Fix # assets}}',
  },
  quietLine: {
    id: 'app.sml.releases.kit.dateRedo.quiet.line',
    defaultMessage: '{count, plural, one {# asset shows} other {# assets show}} the old release date.',
  },
  quietRedo: { id: 'app.sml.releases.kit.dateRedo.quiet.redo', defaultMessage: 'Fix the date' },
  dialogTitle: { id: 'app.sml.releases.kit.dateRedo.dialog.title', defaultMessage: 'Fix the release date' },
  dialogLead: {
    id: 'app.sml.releases.kit.dateRedo.dialog.lead',
    defaultMessage: 'Only the date texts change. Each asset keeps its layout and its look.',
  },
  skipCoverRedo: {
    id: 'app.sml.releases.kit.dateRedo.skip.coverRedo',
    defaultMessage: '{name} has the old cover too. Redo it with the new cover: that fixes the date too.',
  },
  skipBusy: {
    id: 'app.sml.releases.kit.dateRedo.skip.busy',
    defaultMessage: '{name} is being made now, so it gets the new date anyway.',
  },
  beforeReleaseTitle: { id: 'app.sml.releases.kit.dateRedo.before.title', defaultMessage: 'Before release' },
  beforeReleaseCount: {
    id: 'app.sml.releases.kit.dateRedo.before.count',
    defaultMessage: '{count, plural, one {# file with the old date} other {# files with the old date}}',
  },
  beforeReleaseNote: {
    id: 'app.sml.releases.kit.dateRedo.before.note',
    defaultMessage: 'Your song is out, so these pre-save files stay as they are. Do not post them again.',
  },
  progressTitle: {
    id: 'app.sml.releases.kit.dateRedo.progress.title',
    defaultMessage: 'Fixing the release date · {ready} of {total} ready',
  },
  doneTitle: { id: 'app.sml.releases.kit.dateRedo.done.title', defaultMessage: 'Your kit shows the new release date.' },
  failedBody: {
    id: 'app.sml.releases.kit.dateRedo.failed.body',
    defaultMessage: '{ready} of {total} show the new date.',
  },
});
